module.exports = __webpack_public_path__ + "static/media/karelia-medium.0d4c474f.woff2";